import { onlyNumbers, hasAnyLetter } from '@/utils/regex-utils';

export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  empresa(state) {
    return state.empresa;
  },
  localEntrega(state) {
    return state.localEntrega;
  },
  centroCusto(state) {
    return state.centroCusto;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  responsavel(state) {
    return state.responsavel;
  },
  dataInicial(state) {
    return state.dataInicial;
  },
  dataFinal(state) {
    return state.dataFinal;
  },
  urgencia(state) {
    return state.urgencia;
  },
  compradorResponsavel(state) {
    return state.compradorResponsavel;
  },
  grupo(state) {
    return state.grupo;
  },
  situacao(state) {
    return state.situacao;
  },
  listOptions(state) {
    return state.listOptions;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.localEntrega,
      state.responsavel && state.responsavel.length,
      state.produto && state.produto.length,
      state.centroCusto && state.centroCusto.length,
      state.projeto && state.projeto.length,
      state.dataFinal,
      state.dataInicial,
      state.urgencia && state.urgencia.length,
      state.compradorResponsavel && state.compradorResponsavel.length,
      state.grupo && state.grupo.length,
      state.situacao && state.situacao.length,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = [];
    if (state.selectedStatus && state.selectedStatus.value) {
      filters.push(`situacao in ('${state.selectedStatus.value.join('\',\'')}')`);
    }
    if (state.searchText) {
      const idFilter = !hasAnyLetter(state.searchText) ? ` or id = ${onlyNumbers(state.searchText)}` : '';
      filters.push(`(identificador like '%${state.searchText.toLowerCase()}%' or comprador.nome like '%${state.searchText.toLowerCase()}%' or usuario like '%${state.searchText.toLowerCase()}%' or codigoInterno like '%${state.searchText.toLowerCase()}%'${idFilter})`);
    }
    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.localEntrega && state.localEntrega.id) {
      filters.push(`(localEntrega.id = ${state.localEntrega.id})`);
    }
    if (state.responsavel && state.responsavel.length) {
      const responsaveisFilter = state.responsavel.map(responsavel => `(responsavel.id = ${responsavel.id})`);
      filters.push(`(${responsaveisFilter.join(' or ')})`);
    }
    if (state.compradorResponsavel && state.compradorResponsavel.length) {
      const compradorResponsavelFilter = state.compradorResponsavel.map(compradorResponsavel => (compradorResponsavel.id !== 0 ? `(compradorResponsavel.id = ${compradorResponsavel.id})` : 'compradoresResponsaveisTotal = 0'));
      filters.push(`(${compradorResponsavelFilter.join(' or ')})`);
    }
    if (state.centroCusto && state.centroCusto.length) {
      const centroCustosFilter = state.centroCusto.map(centroCusto => `(centroCusto.id = ${centroCusto.id} or produto.centroCusto.id = ${centroCusto.id})`);
      filters.push(`(${centroCustosFilter.join(' or ')})`);
    }
    if (state.produto && state.produto.length) {
      const produtosFilter = state.produto.map(produto => `(produto.id = ${produto.id})`);
      filters.push(`(${produtosFilter.join(' or ')})`);
    }
    if (state.projeto && state.projeto.length) {
      const projetoFilter = state.projeto.map(projeto => `(projeto.id = ${projeto.id} or produto.projeto.id = ${projeto.id})`);
      filters.push(`(${projetoFilter.join(' or ')})`);
    }
    if (state.dataInicial) {
      filters.push(`dataRegistro >= ${state.dataInicial}`);
    }
    if (state.dataFinal) {
      filters.push(`dataRegistro <= ${state.dataFinal}`);
    }
    if (state.urgencia && state.urgencia.length) {
      const urgenciaFilter = state.urgencia.map(urgencia => `(urgencia = '${urgencia}')`);
      filters.push(`(${urgenciaFilter.join(' or ')})`);
    }
    if (state.grupo && state.grupo.length) {
      const grupoFilter = state.grupo.map(categoria => `(produto.categoria.id = ${categoria.id})`);
      filters.push(`(${grupoFilter.join(' or ')})`);
    }
    if (state.situacao && state.situacao.length) {
      const situacaoFilter = state.situacao.map(situacao => `(situacao = '${situacao}')`);
      filters.push(`(${situacaoFilter.join(' or ')})`);
    }
    return filters.join(' and ');
  },
};
